<template>
  <portlet
          :icon="'fad fa-cogs'"
          :title="'Configuration'"
          :actionsBlock="true"
  >
    <template slot="portletBody">
       <div class="row">
        <div class="col-12 col-md-10">
            <h5 class="sm text-sm text-small">Select the company</h5>
            <div class="row">
                <router-link :to="configurationViewLocation(organization)" class="col-3 org-configuration-widget" v-for="organization, key in organizations" v-bind:key="key">
                {{ organization.name }} <i class="fa fa-pencil float-right"></i>
                </router-link>
            </div>
        </div>
       </div>
    </template>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {dataTables} from '../../components/mixins/dataTables.js';
  import {swalModals} from '../../components/mixins/swalModals.js';
  import Vue from 'vue';
  import store from '../../store.js';
  import editUser from '../../components/users/editUser.vue';
  import firebase from 'firebase/app';
  import { Can } from '../../../permission/ability.js';
  import { RIGHTS } from '../roles/rights';
  import { configurationViewLocation } from '../../router/locations';

  export default {
  components: { editUser },
    mixins: [dataTables, swalModals],
    data() {
      return {
        rights: '',
        isAdmin: false,
        organizations: [],
        categories: [],
        user: null,
        nextPageToken: null,
        customFilters: [],
        modalId: null,
      };
    },
  async   created() {
      this.rights = RIGHTS;
      this.$store.commit('setLoading',true)
      await this.fetchUser();
      this.redirectToOrganization();
      await this.fetchOrganizations();
      this.$store.commit('setLoading',false)
      this.isAdmin = this.$store.state.users.me.admin;
      if(this.organizations.length === 1) {
        this.$router.replace(configurationViewLocation(this.organizations[0]));
      }
    },
    methods: {
      Can,
      configurationViewLocation,
      async fetchUser() {
        store.dispatch('users/getMyUserHourApp', {
            ApiClient:   Vue.prototype.$ApiClient,
            departments: store.getters.getUserData.departments
        })
      },
      async fetchOrganizations() {
        await   store.dispatch('organizations/getAll', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments}).then((res) => {
          if (res.status === 200) {
            this.organizations = res.data.data;
          }
        }).catch((err) => {

        });
      },
      redirectToOrganization() {
        const hourAppUser = this.$store.state.users.hourAppUser;
        if (hourAppUser && hourAppUser.profile_type === 'Client') {
          const org = hourAppUser.organization;
          this.$router.replace(configurationViewLocation(org));
        }
      }
    },
    computed: {
      ...mapGetters('roles', ['getRoles']),
    },
  };
</script>

<style lang="scss" scoped>
h5 {
    font-size: smaller;
    margin-bottom: 2rem;
}
.org-configuration-widget {
    background-color: #E7F1F1;
    color: #146F70;
    border-radius: 10px;
    padding: 1rem 2rem;
    text-transform: capitalize;
    cursor: pointer;

    i {
        margin-top: 5px;
        padding-bottom: 2px;
        border-bottom: 1px solid #146F70;
    }
}
</style>